export class PeriodoExtrato {
    static Ontem: PeriodoExtrato = new PeriodoExtrato(1, 'Ontem')
    static Ultimos7Dias: PeriodoExtrato = new PeriodoExtrato(
        2,
        'Últimos 7 dias'
    )
    static Ultimos15Dias: PeriodoExtrato = new PeriodoExtrato(
        3,
        'Últimos 15 dias'
    )
    static Ultimos30Dias: PeriodoExtrato = new PeriodoExtrato(
        4,
        'Últimos 30 dias'
    )
    static Personalizado: PeriodoExtrato = new PeriodoExtrato(
        5,
        'Data personalizada'
    )

    id: number
    descricao: string

    constructor(id: number, descricao: string) {
        this.id = id
        this.descricao = descricao
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/shared/periodo-extrato.ts